import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Uploader from '../Uploader';

class MultiUploader extends Component {
  static defaultProps = {
    onChange: () => undefined,
    title: 'Upload legal documentation',
    supportedTypes: ['jpg', 'png', 'pdf'],
  };

  static propTypes = {
    onChange: PropTypes.func,
    title: PropTypes.string,
    supportedTypes: PropTypes.arrayOf(PropTypes.string),
  };

  constructor(props) {
    super(props);
    this.state = {
      uploadedFiles: [],
      uploaders: [this.getUploader(0)],
    };
  }


  onUploadFinish() {
    const { onChange } = this.props;
    const { uploadedFiles } = this.state;
    const files = uploadedFiles.filter((item) => item != null);
    onChange(files);
  }

  handleOnError = (index) => {
    this.setState(({ uploadedFiles }) => {
      uploadedFiles[index] = null;
      return {
        uploadedFiles,
      };
    }, this.onUploadFinish);
  };

  handleUploaderOnSuccess = (file, index) => {
    this.setState(({ uploadedFiles, uploaders }) => {
      const existUploaderUpdated = !!uploadedFiles[index];
      uploadedFiles[index] = file;
      return {
        uploadedFiles,
        uploaders: existUploaderUpdated ? uploaders : [...uploaders, this.getUploader(index + 1)],
      };
    }, this.onUploadFinish);
  };


  getUploader = (index) => {
    const { title,supportedTypes } = this.props;
    return (
      <div key={index} className="mr-4 mb-4">
        <Uploader
          supportedTypes={supportedTypes}
          onSuccess={(data) => this.handleUploaderOnSuccess(data, index)}
          title={title}
          onError={() => this.handleOnError(index)}
          onRemove={() => this.onRemove(index)}
        />
      </div>
    );
  };

  onRemove = (index) => {
    this.setState(({ uploadedFiles, uploaders }) => ({
      uploadedFiles: uploadedFiles.map((item, i) => (i === index ? null : item)),
      uploaders: uploaders.map((item, i) => (i === index ? null : item)),
    }), this.onUploadFinish);
  };

  render() {
    const { uploaders } = this.state;
    return (
      <>
        {uploaders}
      </>
    );
  }
}

export default MultiUploader;
